import styled, { css } from 'styled-components';

import { AvatarSize } from '@pkg/components';
import { styledLayout, styledMedia, styledReset } from '@pkg/primitives';

import { type EditableImageSize } from './types';

interface EditableImageWrapperProps {
    $size: EditableImageSize;
}

export const EditableImageWrapper = styled.div<EditableImageWrapperProps>`
    --yat_editable-image-font-size: 13px;
    --yat_editable-image-overlay-icon-size: 28px;

    // TODO: Is there a better pattern for this using styled-components?
    ${({ $size }) => {
        if ($size === AvatarSize.Smallest) {
            return css`
                --yat_editable-image-overlay-icon-size: 20px;
            `;
        }

        if ($size === AvatarSize.Smaller) {
            return css`
                --yat_editable-image-overlay-icon-size: 20px;
            `;
        }

        if ($size === AvatarSize.Medium) {
            return css`
                --yat_editable-image-font-size: 16px;
            `;
        }
    }}
`;

export const Action = styled.button.attrs({ type: 'button' })`
    // Required to combat v2-global-reset
    && {
        ${styledReset.button}
        position: relative;
    }

    &[disabled] {
        pointer-events: none;
    }
`;

///
/// Overlay

export const Overlay = styled.div`
    ${styledLayout.positionCover()}
    display: grid;
    place-items: center;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.shades.white[20]};
    border-radius: 50%;
    box-shadow: inset 0 0 var(--yat_editable-image-size) ${({ theme }) => theme.shades.black[55]};
    opacity: 0;
    pointer-events: none;
    transition-property: opacity;
    transition-duration: ${({ theme }) => theme.transitions.speeds.fast}s;
    transition-timing-function: ${({ theme }) => theme.transitions.easesCss.cubic};

    ${Action}:hover & {
        opacity: 1;
    }

    ${Action}:active & {
        opacity: 0.8;
    }
`;

export const OverlayContent = styled.div`
    display: grid;
    justify-items: center;
    gap: 6px;
    // TODO: A 'scale' transition would be nice...
    // but its typically pretty janky.
`;

export const OverlayIconWrapper = styled.div`
    ${styledMedia.iconWrapper}
    width: var(--yat_editable-image-overlay-icon-size);
    height: var(--yat_editable-image-overlay-icon-size);
`;

export const OverlayText = styled.span`
    ${styledReset.typography}
    display: block;
    font-family: 'Alliance No.1';
    font-size: var(--yat_editable-image-font-size);
    font-weight: 700;
`;
